import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "registration-verify" }
const _hoisted_2 = { class: "description" }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$setup.showError)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Verify your email address", -1)),
          _createElementVNode("div", _hoisted_2, [
            _cache[0] || (_cache[0] = _createTextVNode("We emailed a confirmation link to ", -1)),
            _createElementVNode("span", null, _toDisplayString($setup.email.toLowerCase()), 1)
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "check" }, "Check your email for a link to continue", -1)),
          _createElementVNode("button", {
            class: "button",
            onClick: $setup.onResend
          }, "Resend email")
        ], 64))
      : (_openBlock(), _createElementBlock("h2", _hoisted_3, "Something went wrong"))
  ]))
}